/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetUserForSettingsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetUserForSettingsQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly magicAutoRunOnKeep: boolean;
    readonly vimMode: boolean;
    readonly userSettings: c.PartialUserSettings;
  } | null;
};

export const GetUserForSettingsDocument = /*#__PURE__*/ gql`
  query GetUserForSettings {
    me {
      id
      magicAutoRunOnKeep
      vimMode
      userSettings
    }
  }
`;

/**
 * __useGetUserForSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserForSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserForSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserForSettingsQuery,
    GetUserForSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserForSettingsQuery,
    GetUserForSettingsQueryVariables
  >(GetUserForSettingsDocument, options);
}
export function useGetUserForSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserForSettingsQuery,
    GetUserForSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserForSettingsQuery,
    GetUserForSettingsQueryVariables
  >(GetUserForSettingsDocument, options);
}
export function useGetUserForSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserForSettingsQuery,
    GetUserForSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserForSettingsQuery,
    GetUserForSettingsQueryVariables
  >(GetUserForSettingsDocument, options);
}
export type GetUserForSettingsQueryHookResult = ReturnType<
  typeof useGetUserForSettingsQuery
>;
export type GetUserForSettingsLazyQueryHookResult = ReturnType<
  typeof useGetUserForSettingsLazyQuery
>;
export type GetUserForSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetUserForSettingsSuspenseQuery
>;
export type GetUserForSettingsQueryResult = Apollo.QueryResult<
  GetUserForSettingsQuery,
  GetUserForSettingsQueryVariables
>;
